// Manually maintained index of web/public/models SVG and WebP assets (lobe-icons, MIT).
// opencode-color.svg is the favicon published by https://opencode.ai/favicon.svg.
// opendesign-color.svg is the logo published by https://open-design.ai/images/download-logo.svg.
// minimax-account-color.webp is a lossless conversion of https://www.minimax.io/favicon.ico.
// Keep it in sync with the asset-set assertion in tests/lib/modelIcon.test.ts.
// Used by ModelIcon to pick a '-color' brand variant when available, else the mono base.
export const MODEL_ICON_SLUGS: ReadonlySet<string> = new Set([
  'ace-text',
  'ace',
  'adobe-color',
  'adobe-text',
  'adobe',
  'adobefirefly-color',
  'adobefirefly-text',
  'adobefirefly',
  'agentvoice-color',
  'agentvoice-text',
  'agentvoice',
  'agui-text',
  'agui',
  'ai2-color',
  'ai2-text',
  'ai2',
  'ai21-brand-color',
  'ai21-brand',
  'ai21-text',
  'ai21',
  'ai302-color',
  'ai302-text',
  'ai302',
  'ai360-color',
  'ai360-text',
  'ai360',
  'aihubmix-color',
  'aihubmix-text',
  'aihubmix',
  'aimass-color',
  'aimass-text',
  'aimass',
  'aionlabs-color',
  'aionlabs-text',
  'aionlabs',
  'airjelly-color',
  'airjelly-text',
  'airjelly',
  'aistudio-text',
  'aistudio',
  'akashchat-color',
  'akashchat-text',
  'akashchat',
  'alephalpha-text',
  'alephalpha',
  'alibaba-brand-color',
  'alibaba-brand',
  'alibaba-color',
  'alibaba-text-cn',
  'alibaba-text',
  'alibaba',
  'alibabacloud-color',
  'alibabacloud-text-cn',
  'alibabacloud-text',
  'alibabacloud',
  'amp-color',
  'amp-text',
  'amp',
  'antgroup-brand-color',
  'antgroup-brand',
  'antgroup-color',
  'antgroup-text-cn',
  'antgroup-text',
  'antgroup',
  'anthropic-text',
  'anthropic',
  'antigravity-color',
  'antigravity-text',
  'antigravity',
  'anyscale-color',
  'anyscale-text',
  'anyscale',
  'apertis-color',
  'apertis-text',
  'apertis',
  'apple-text',
  'apple',
  'arcee-color',
  'arcee-text',
  'arcee',
  'askverdict-color',
  'askverdict-text',
  'askverdict',
  'assemblyai-color',
  'assemblyai-text',
  'assemblyai',
  'atlascloud-text',
  'atlascloud',
  'automatic-color',
  'automatic-text',
  'automatic',
  'aws-brand-color',
  'aws-brand',
  'aws-color',
  'aws-text',
  'aws',
  'aya-color',
  'aya-text',
  'aya',
  'azure-color',
  'azure-text',
  'azure',
  'azureai-color',
  'azureai-text',
  'azureai',
  'baai-text',
  'baai',
  'baichuan-color',
  'baichuan-text',
  'baichuan',
  'baidu-brand-color',
  'baidu-brand',
  'baidu-color',
  'baidu-text-cn',
  'baidu-text',
  'baidu',
  'baiducloud-color',
  'baiducloud-text',
  'baiducloud',
  'bailian-color',
  'bailian-text',
  'bailian',
  'baseten-text',
  'baseten',
  'bedrock-color',
  'bedrock-text',
  'bedrock',
  'bfl-text',
  'bfl',
  'bilibili-color',
  'bilibili-text',
  'bilibili',
  'bilibiliindex-text',
  'bilibiliindex',
  'bing-color',
  'bing-text',
  'bing',
  'briaai-color',
  'briaai-text',
  'briaai',
  'burncloud-color',
  'burncloud-text',
  'burncloud',
  'bytedance-brand-color',
  'bytedance-brand',
  'bytedance-color',
  'bytedance-text-cn',
  'bytedance-text',
  'bytedance',
  'capcut-text',
  'capcut',
  'centml-brand-color',
  'centml-brand',
  'centml-color',
  'centml-text',
  'centml',
  'cerebras-brand-color',
  'cerebras-brand',
  'cerebras-color',
  'cerebras-text',
  'cerebras',
  'chatglm-color',
  'chatglm-text',
  'chatglm',
  'cherrystudio-color',
  'cherrystudio-text',
  'cherrystudio',
  'civitai-color',
  'civitai-text-color',
  'civitai-text',
  'civitai',
  'claude-color',
  'claude-text',
  'claude',
  'claudecode-color',
  'claudecode-text',
  'claudecode',
  'cline-text',
  'cline',
  'clipdrop-text',
  'clipdrop',
  'cloudflare-color',
  'cloudflare-text',
  'cloudflare',
  'codebuddy-color',
  'codebuddy-text',
  'codebuddy',
  'codeflicker-color',
  'codeflicker-text',
  'codeflicker',
  'codegeex-color',
  'codegeex-text',
  'codegeex',
  'codex-color',
  'codex-text',
  'codex',
  'cogvideo-color',
  'cogvideo-text',
  'cogvideo',
  'cogview-color',
  'cogview-text',
  'cogview',
  'cohere-color',
  'cohere-text',
  'cohere',
  'colab-color',
  'colab-text',
  'colab',
  'cometapi-color',
  'cometapi-text',
  'cometapi',
  'comfyui-color',
  'comfyui-text',
  'comfyui',
  'command',
  'commanda-color',
  'commanda-text',
  'commanda',
  'copilot-color',
  'copilot-text',
  'copilot',
  'copilotkit-color',
  'copilotkit-text',
  'copilotkit',
  'coqui-color',
  'coqui-text',
  'coqui',
  'coze-text',
  'coze',
  'crewai-brand-color',
  'crewai-brand',
  'crewai-color',
  'crewai-text',
  'crewai',
  'crusoe-color',
  'crusoe-text',
  'crusoe',
  'cursor-text',
  'cursor',
  'cybercut-text',
  'cybercut',
  'dalle-color',
  'dalle-text',
  'dalle',
  'dbrx-brand-color',
  'dbrx-brand',
  'dbrx-color',
  'dbrx-text',
  'dbrx',
  'deepai-text',
  'deepai',
  'deepcogito-color',
  'deepcogito-text',
  'deepcogito',
  'deepinfra-color',
  'deepinfra-text',
  'deepinfra',
  'deepl-color',
  'deepl-text',
  'deepl',
  'deepmind-color',
  'deepmind-text',
  'deepmind',
  'deepseek-color',
  'deepseek-text',
  'deepseek',
  'devin-color',
  'devin-text',
  'devin',
  'dify-color',
  'dify-text',
  'dify',
  'doc2x-color',
  'doc2x-text',
  'doc2x',
  'docsearch-color',
  'docsearch-text',
  'docsearch',
  'dolphin-text',
  'dolphin',
  'doubao-color',
  'doubao-text',
  'doubao',
  'dreammachine-text',
  'dreammachine',
  'elevenlabs-text',
  'elevenlabs',
  'elevenx-text',
  'elevenx',
  'essentialai-color',
  'essentialai-text',
  'essentialai',
  'exa-color',
  'exa-text',
  'exa',
  'fal-color',
  'fal-text',
  'fal',
  'fastgpt-color',
  'fastgpt-text',
  'fastgpt',
  'featherless-color',
  'featherless-text',
  'featherless',
  'figma-color',
  'figma-text',
  'figma',
  'fireworks-color',
  'fireworks-text',
  'fireworks',
  'fishaudio-text',
  'fishaudio',
  'flora-text',
  'flora',
  'flowith-text',
  'flowith',
  'flux-text',
  'flux',
  'friendli-text',
  'friendli',
  'gemini-color',
  'gemini-text',
  'gemini',
  'geminicli-color',
  'geminicli-text',
  'geminicli',
  'gemma-color',
  'gemma-text',
  'gemma',
  'giteeai-text',
  'giteeai',
  'github-text',
  'github',
  'githubcopilot-text',
  'githubcopilot',
  'glama-text',
  'glama',
  'glif-text',
  'glif',
  'glmv-color',
  'glmv-text',
  'glmv',
  'google-brand-color',
  'google-brand',
  'google-color',
  'google',
  'googlecloud-brand-color',
  'googlecloud-brand',
  'googlecloud-color',
  'googlecloud',
  'goose-text',
  'goose',
  'gradio-color',
  'gradio-text',
  'gradio',
  'greptile-color',
  'greptile-text',
  'greptile',
  'grok-text',
  'grok',
  'groq-text',
  'groq',
  'hailuo-color',
  'hailuo-text',
  'hailuo',
  'haiper-text',
  'haiper',
  'hedra-text',
  'hedra',
  'higress-color',
  'higress-text',
  'higress',
  'huawei-color',
  'huawei-text-cn',
  'huawei-text',
  'huawei',
  'huaweicloud-color',
  'huaweicloud-text-cn',
  'huaweicloud-text',
  'huaweicloud',
  'huggingface-color',
  'huggingface-text',
  'huggingface',
  'hunyuan-color',
  'hunyuan-text',
  'hunyuan',
  'hyperbolic-color',
  'hyperbolic-text',
  'hyperbolic',
  'ibm-text',
  'ibm',
  'ideogram-text',
  'ideogram',
  'iflytekcloud-color',
  'iflytekcloud-text',
  'iflytekcloud',
  'inception-text',
  'inception',
  'inference-text',
  'inference',
  'infermatic-color',
  'infermatic-text',
  'infermatic',
  'infinigence-color',
  'infinigence-text-cn',
  'infinigence-text',
  'infinigence',
  'inflection-text',
  'inflection',
  'internlm-color',
  'internlm-text',
  'internlm',
  'jimeng-color',
  'jimeng-text',
  'jimeng',
  'jina-text',
  'jina',
  'junie-color',
  'junie-text',
  'junie',
  'kilocode-text',
  'kilocode',
  'kimi-text',
  'kimi',
  'kiro-color',
  'kiro-text',
  'kiro',
  'kling-color',
  'kling-text',
  'kling',
  'kluster-color',
  'kluster-text',
  'kluster',
  'kolors-color',
  'kolors-text',
  'kolors',
  'krea-text',
  'krea',
  'kwaikat-text-color',
  'kwaikat-text',
  'kwaikat',
  'kwaipilot-color',
  'kwaipilot-text',
  'kwaipilot',
  'lambda-text',
  'lambda',
  'langchain-color',
  'langchain-text',
  'langchain',
  'langfuse-color',
  'langfuse-text',
  'langfuse',
  'langgraph-color',
  'langgraph-text',
  'langgraph',
  'langsmith-color',
  'langsmith-text',
  'langsmith',
  'leptonai-color',
  'leptonai-text',
  'leptonai',
  'lg-color',
  'lg-text',
  'lg',
  'lightricks-text',
  'lightricks',
  'liquid-text',
  'liquid',
  'livekit-color',
  'livekit-text',
  'livekit',
  'llamaindex-color',
  'llamaindex-text',
  'llamaindex',
  'llava-color',
  'llava-text',
  'llava',
  'llmapi-color',
  'llmapi-text',
  'llmapi',
  'lmstudio-text',
  'lmstudio',
  'lobehub-color',
  'lobehub-text',
  'lobehub',
  'longcat-color',
  'longcat-text',
  'longcat',
  'lovable-color',
  'lovable-text',
  'lovable',
  'lovart-text',
  'lovart',
  'luma-color',
  'luma-text',
  'luma',
  'magic-text',
  'magic',
  'make-color',
  'make-text',
  'make',
  'manus-text',
  'manus',
  'mastra-text',
  'mastra',
  'mcp-text',
  'mcp',
  'mcpso-color',
  'mcpso-text',
  'mcpso',
  'menlo-color',
  'menlo-text',
  'menlo',
  'meshy-color',
  'meshy-text',
  'meshy',
  'meta-brand-color',
  'meta-brand',
  'meta-color',
  'meta-text',
  'meta',
  'metaai-color',
  'metaai-text',
  'metaai',
  'metagpt-text',
  'metagpt',
  'microsoft-color',
  'microsoft-text',
  'microsoft',
  'midjourney-text',
  'midjourney',
  'minimax-account-color',
  'minimax-color',
  'minimax-text',
  'minimax',
  'mistral-color',
  'mistral-text',
  'mistral',
  'modelscope-color',
  'modelscope-text',
  'modelscope',
  'monica-color',
  'monica-text',
  'monica',
  'moonshot-text',
  'moonshot',
  'morph-color',
  'morph-text',
  'morph',
  'moxt-color',
  'moxt-text',
  'moxt',
  'myshell-color',
  'myshell-text',
  'myshell',
  'n8n-color',
  'n8n-text',
  'n8n',
  'nanobanana-color',
  'nanobanana-text',
  'nanobanana',
  'nebius-text',
  'nebius',
  'newapi-color',
  'newapi-text',
  'newapi',
  'notebooklm-text',
  'notebooklm',
  'notion-text',
  'notion',
  'nousresearch-text',
  'nousresearch',
  'nova-color',
  'nova-text',
  'nova',
  'novelai-text',
  'novelai',
  'novita-color',
  'novita-text',
  'novita',
  'nplcloud-color',
  'nplcloud-text',
  'nplcloud',
  'nvidia-color',
  'nvidia-text',
  'nvidia',
  'obsidian-color',
  'obsidian-text',
  'obsidian',
  'ollama-text',
  'ollama',
  'openai-text',
  'openai',
  'openchat-color',
  'openchat-text',
  'openchat',
  'openclaw-color',
  'openclaw-text',
  'openclaw',
  'opencode-color',
  'opencode-text',
  'opencode',
  'opendesign-color',
  'openhands-color',
  'openhands-text',
  'openhands',
  'openhuman-text',
  'openhuman',
  'openrouter-text',
  'openrouter',
  'openwebui-text',
  'openwebui',
  'palm-color',
  'palm-text',
  'palm',
  'parasail-text',
  'parasail',
  'perplexity-color',
  'perplexity-text',
  'perplexity',
  'phidata-color',
  'phidata-text',
  'phidata',
  'phind-text',
  'phind',
  'pika-text',
  'pika',
  'pixverse-color',
  'pixverse-text',
  'pixverse',
  'player2-color',
  'player2-text',
  'player2',
  'poe-color',
  'poe-text',
  'poe',
  'pollinations-text',
  'pollinations',
  'ppio-color',
  'ppio-text-cn',
  'ppio-text',
  'ppio',
  'prunaai-color',
  'prunaai-text',
  'prunaai',
  'pydanticai-color',
  'pydanticai-text',
  'pydanticai',
  'qingyan-color',
  'qingyan-text',
  'qingyan',
  'qiniu-color',
  'qiniu-text',
  'qiniu',
  'qoder-color',
  'qoder-text',
  'qoder',
  'qwen-color',
  'qwen-text',
  'qwen',
  'railway-text',
  'railway',
  'recraft-text',
  'recraft',
  'relace-text',
  'relace',
  'replicate-brand',
  'replicate-text',
  'replicate',
  'replit-color',
  'replit-text',
  'replit',
  'reve-text',
  'reve',
  'roocode-text',
  'roocode',
  'rsshub-color',
  'rsshub-text',
  'rsshub',
  'runway-text',
  'runway',
  'rwkv-color',
  'rwkv-text',
  'rwkv',
  'sambanova-color',
  'sambanova-text',
  'sambanova',
  'search1api-color',
  'search1api-text',
  'search1api',
  'searchapi-text',
  'searchapi',
  'sensenova-brand-color',
  'sensenova-brand',
  'sensenova-color',
  'sensenova-text',
  'sensenova',
  'siliconcloud-color',
  'siliconcloud-text',
  'siliconcloud',
  'sillytavern-color',
  'sillytavern-text',
  'sillytavern',
  'skywork-color',
  'skywork-text',
  'skywork',
  'slock-text',
  'slock',
  'smithery-color',
  'smithery-text',
  'smithery',
  'snowflake-color',
  'snowflake-text',
  'snowflake',
  'sophnet-color',
  'sophnet-text',
  'sophnet',
  'sora-color',
  'sora-text',
  'sora',
  'spark-color',
  'spark-text',
  'spark',
  'speedai-color',
  'speedai-text',
  'speedai',
  'stability-brand-color',
  'stability-brand',
  'stability-color',
  'stability-text',
  'stability',
  'statecloud-color',
  'statecloud-text',
  'statecloud',
  'stepfun-color',
  'stepfun-text',
  'stepfun',
  'straico-color',
  'straico-text',
  'straico',
  'streamlake-color',
  'streamlake-text',
  'streamlake',
  'submodel-color',
  'submodel-text',
  'submodel',
  'suno-text',
  'suno',
  'sync-text',
  'sync',
  'targon-color',
  'targon-text',
  'targon',
  'tavily-color',
  'tavily-text',
  'tavily',
  'tencent-brand-color',
  'tencent-brand',
  'tencent-color',
  'tencent-text-cn',
  'tencent-text',
  'tencent',
  'tencentcloud-color',
  'tencentcloud-text',
  'tencentcloud',
  'tiangong-color',
  'tiangong-text',
  'tiangong',
  'tii-color',
  'tii-text',
  'tii',
  'together-brand-color',
  'together-brand',
  'together-color',
  'together-text',
  'together',
  'topazlabs-text',
  'topazlabs',
  'trae-color',
  'trae-text',
  'trae',
  'tripo-color',
  'tripo-text',
  'tripo',
  'turix-text',
  'turix',
  'udio-color',
  'udio-text',
  'udio',
  'unstructured-color',
  'unstructured-text',
  'unstructured',
  'upstage-color',
  'upstage-text',
  'upstage',
  'v0',
  'vectorizerai-text',
  'vectorizerai',
  'venice-color',
  'venice-text',
  'venice',
  'vercel-text',
  'vercel',
  'vertexai-color',
  'vertexai-text',
  'vertexai',
  'vidu-color',
  'vidu-text',
  'vidu',
  'viggle-text',
  'viggle',
  'vllm-color',
  'vllm-text',
  'vllm',
  'volcengine-color',
  'volcengine-text',
  'volcengine',
  'voyage-color',
  'voyage-text',
  'voyage',
  'wenxin-color',
  'wenxin-text',
  'wenxin',
  'windsurf-text',
  'windsurf',
  'workersai-color',
  'workersai-text',
  'workersai',
  'worldrouter-text',
  'worldrouter',
  'xai-text',
  'xai',
  'xiaomimimo-color',
  'xiaomimimo-text',
  'xiaomimimo',
  'xinference-color',
  'xinference-text',
  'xinference',
  'xpay-color',
  'xpay-text',
  'xpay',
  'xuanyuan-color',
  'xuanyuan-text',
  'xuanyuan',
  'yandex-text',
  'yandex',
  'yi-color',
  'yi-text',
  'yi',
  'youmind-text',
  'youmind',
  'yuanbao-color',
  'yuanbao-text',
  'yuanbao',
  'zai-text',
  'zai',
  'zapier-color',
  'zapier-text',
  'zapier',
  'zeabur-color',
  'zeabur-text',
  'zeabur',
  'zencoder-color',
  'zencoder-text',
  'zencoder',
  'zenmux-text',
  'zenmux',
  'zeroone-color',
  'zeroone-text',
  'zeroone',
  'zhipu-color',
  'zhipu-text',
  'zhipu',
]);
